import { Injectable, inject } from '@angular/core';
import { UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class CanReadAdminGuard {
  private authService = inject(AuthenticationService);
  private router = inject(Router);

  public canActivateChild(): Observable<boolean | UrlTree> {
    return this.canActivate();
  }

  public canActivate(): Observable<boolean | UrlTree> {
    return this.authService.whenProfileReady$.pipe(
      switchMap(() => this.authService.canReadAdmin()),
      tap((canReadAdmin) => {
        if (!canReadAdmin) {
          this.authService.setUrlAfterLogin();
        }
      }),
      map((canReadAdmin) => {
        if (!canReadAdmin) {
          return this.router.parseUrl('/user/login');
        }

        return true;
      }),
    );
  }
}
